import { TypePolicy } from '@apollo/client';

const TelehealthMeeting: TypePolicy = {
  keyFields: ['telehealthMeetingId'],
};

export default TelehealthMeeting;
